import { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import FeedbackModal from "./FeedbackModal";

export default function FeedbackButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="relative inline-flex h-10 w-10 items-center justify-center rounded-full hover:bg-gray-100"
        title="Gửi phản hồi"
        aria-label="Gửi phản hồi"
      >
        <MessageSquarePlus className="h-6 w-6 text-gray-700" strokeWidth={1.5} />
      </button>
      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
